
import './firstSection.sass'

export const FirstSectionError = () => {
    return (
        <>
        
        <div className='h-[8.5vh]'></div>
        <div className='text-5xl h-[40vh] flex justify-center items-center'>
            
            <p>oups! <span className='text-red-400'>ERROR 404</span></p>
            
            
        </div>
        </>
        
    );
};

